import ApiHelper from "@/helpsers/api.helper";
import { defineStore } from "pinia";
import axios from "axios";
import authHelper from "@/helpsers/auth.helper";
import { ref } from "vue";

export const useCurrencyStore = defineStore("currencyStore", () => {
  /**
   * @type {import('vue').Ref<{currency: string; rate: string}[]>}
   */
  const currencies = ref();
  /**
   * Default currency is PLN
   */
  async function getCurrencies() {
    try {
      const res = await axios.get(ApiHelper.getCurrencyUrl(), {
        headers: authHelper.authHeader(),
      });
      currencies.value = res.data;
    } catch (error) {
      console.error(error);
    }
  }
  return {
    currencies,
    getCurrencies,
  };
});
